import Axios from '../../libs/strataIns';

export default {
  state: {
    usersMeta: {},
    users: [],
    account: {},
    filteredUsers: [],
    filteredSellers: [],
    filteredUser: {},
    // orderStatus: {},
  },

  getters: {
    filteredUsers: (state) => state.filteredUsers,
    filteredSellers: (state) => state.filteredSellers,
    usersMeta: (state) => state.usersMeta,
    users: (state) => state.users,
    account: (state) => state.account,
    filteredUser: (state) => state.filteredUser,
  },

  mutations: {
    setUser(state, payload) {
      state.filteredUser = {...payload}
    },
    setAccount(state, payload) {
      state.account = {...payload}
    },
    setFilteredUsers(state, payload) {
      state.filteredUsers = [...payload]
    },
    setSupplier(state, payload) {
      state.supplier = {...payload}
    },
    setSellers(state, payload) {
      state.filteredSellers = [...payload]
    },
    removeUser(state, payload) {
      let index = state.filteredUsers.findIndex(el => el.id == payload);
      state.filteredUsers.splice(index, 1);
    },
    setUsersData(state, payload) {
      state.usersMeta = {...payload.meta};
      state.users = [...payload.results];
    }

  },

  actions: {
    getUsers({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/accounts`, {}, {
          params: {
            page: payload.page,
            role: payload.role,
            keywords: payload.keywords,
            export: payload.export,
            limit: payload.limit
          }
        })
        .then(res => {
          if(res.data.results != null) {
            commit('setUsersData', res.data);
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    }, 
    getFilteredUsers({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/accounts`, {
          
        }, {
          params: {
            id: payload.id,
            perm: payload.perm,
            role: payload.role,
            keywords: payload.keywords,
            page: payload.page,
            export: payload.export,
            limit: payload.limit
          }
        })
        .then(res => {
          if(res.data.results != null) {
            commit('setFilteredUsers', res.data.results);
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    }, 

    getUser({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/accounts/show/${payload}`, {
        })
        .then(res => {
          if(res.data.results != null) {
            commit('setAccount', res.data.results);
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    },
  

    createUser({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/accounts/save`, {
          id: payload.id,
          name: payload.name,
          email: payload.email,
          phone: payload.phone,
          password: payload.password,
          role_id: payload.role_id,
          status: payload.status
        })
        .then(res => {
          if(res.data.results != null) {
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    }, 
    deleteUser({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`admin/accounts/delete/${payload}`, {})
        .then(res => {
          if(res.data.results != null) {
            commit('removeUser', payload)
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    },
  }
}